/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
import { url } from '../../../utils/urls';
// import { hoverTransition, aniSpeed } from '../../../utils/styles/general';



/* ++++++++++ --------------- NO DATA - STATE : STYLES --------------- ++++++++++ */
export default {
	nodatastate: {
		backgroundColor: themeV2.color.base.white,
        // backgroundImage: `url(${url.image}/illustration-bubble-background.svg)`,
        // backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto 100%',
        backgroundPosition: '100% 100%',
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        padding: replacePXinStringWithEM('40px 40px'),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .content': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            '& .graphic': {
                backgroundColor: 'transparent',
                backgroundImage: `url(${url.image}/illustration-500.svg)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'auto 100%',
                backgroundPosition: '100% 100%',
                // boxShadow: replacePXinStringWithEM('0px 8px 16px 0px rgba(213, 231, 253, 0.9)'),
                width: pxToEm(175),
                height: pxToEm(175),
                borderRadius: pxToEm(8),
                marginRight: pxToEm(50),
            },
            '& .desc': {
                flex: '1',
                // minWidth: pxToEm(150),
                // maxWidth: pxToEm(350),
                '& h2': {
                    fontSize: pxToEm(26),
                    fontWeight: 'normal',
                    lineHeight: pxToEm(22),
                    marginBottom: pxToEm(10)
                },
                '& h3': {
                    color: 'rgb(37, 79, 184)',
                    fontSize: pxToEm(24),
                    fontWeight: 'normal',
                    marginBottom: pxToEm(15)
                },
                '& h4': {
                    fontSize: pxToEm(15),
                    fontFamily: 'arial',
                    fontWeight: 'bold',
                    marginBottom: pxToEm(8)
                },
                '& p': {
                    color: themeV2.color.base.gray.dark,
                    fontSize: pxToEm(16),
                    lineHeight: pxToEm(24),
                    marginBottom: pxToEm(10)
                },
                '& .note': {
                	color: themeV2.color.base.gray.secondary,
                	marginTop: pxToEm(20),
                	fontSize: '80%'
                }
            }
        },
        '&.variant': {
            '&-small': {
                fontSize: '85%',
                '& .graphic': {
                    fontSize: '70%'
                }
            },
            '&-noBackground': {
                backgroundColor: 'transparent',
            }
        }
	}
};
